import { call, delay } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'

export default function * requestMarkBoardAsRead (action) {
  const { id, onSuccess } = action.payload

  yield delay(1000)

  try {
    yield call(apiAction, 'MarkBoardAsRead', {
      boardId: id
    })

    onSuccess && onSuccess()
  } catch (e) {} // eslint-disable-line no-empty
}
